import { SvgIcon } from "@mui/material";
import React from "react";
export const RecommendationViewIcon = (props) => (React.createElement(SvgIcon, { ...props },
    React.createElement("rect", { x: "1.5", y: "1.5", width: "9.75", height: "21" }),
    React.createElement("rect", { x: "18.37", y: "1.5", width: "4.13", height: "21" }),
    React.createElement("rect", { x: "12.75", y: "1.5", width: "4.12", height: "21" })));
export const GridViewIcon = (props) => (React.createElement(SvgIcon, { ...props },
    React.createElement("rect", { x: "1.49", y: "1.5", width: "6", height: "6" }),
    React.createElement("rect", { x: "8.99", y: "1.5", width: "6", height: "6" }),
    React.createElement("rect", { x: "16.49", y: "1.5", width: "6", height: "6" }),
    React.createElement("rect", { x: "1.49", y: "9", width: "6", height: "6" }),
    React.createElement("rect", { x: "8.99", y: "9", width: "6", height: "6" }),
    React.createElement("rect", { x: "16.49", y: "9", width: "6", height: "6" }),
    React.createElement("rect", { x: "1.49", y: "16.5", width: "6", height: "6" }),
    React.createElement("rect", { x: "8.99", y: "16.5", width: "6", height: "6" }),
    React.createElement("rect", { x: "16.49", y: "16.5", width: "6", height: "6" })));
export const TableViewIcon = (props) => (React.createElement(SvgIcon, { ...props },
    React.createElement("rect", { x: "1.5", y: "1.5", width: "6", height: "6" }),
    React.createElement("rect", { x: "9", y: "1.5", width: "6", height: "6" }),
    React.createElement("rect", { x: "16.5", y: "1.5", width: "6", height: "6" }),
    React.createElement("rect", { x: "1.5", y: "9", width: "6", height: "13.5" }),
    React.createElement("rect", { x: "9", y: "9", width: "6", height: "13.5" }),
    React.createElement("rect", { x: "16.5", y: "9", width: "6", height: "13.5" })));
//# sourceMappingURL=selection-icons.js.map